import {
  ChatIconButton,
  Logo,
  ProfileMenu,
  NotificationMenu,
  MobileHeader,
} from "@/components/Header";
import { usePersonalDetailsQuery } from "@/fetch/profiles";
import { useRouter } from "next/router";
import Avatar from "@/components/Avatar";
import { IconButton } from "@/components/Button";
import { Skeleton } from "@/components/Loader";
import { GroupSecondIcon, AvatarIcon } from "@/components/Icon";
import styles from "./SocialMobileHeader.module.scss";
import { useRoutes, useDialog } from "@/hooks";
import { TopLevelDialogNames } from "@/components/TopLevelDialogs";
import Typography from "@/components/Typography";
import { MobileProfileMenu } from "@/components/Header";

const SocialMobileHeader: React.FC = () => {
  const router = useRouter();
  const { data: personalDetails, isLoading: isPersonalDetailsLoading } =
    usePersonalDetailsQuery();
  const profilePictureCloudinaryPath =
    personalDetails?.traveller?.s3_profile_pic;
  const { hasAccessToRoute } = useRoutes();
  const { openTopLevelDialog } = useDialog();
  const hasSocialAccess = hasAccessToRoute("Social");

  const onProfileClick = () => {
    router.push({ pathname: `/social/profile` });
  };

  return (
    <MobileHeader className={styles.header}>
      {hasSocialAccess ? (
        <div className={styles.textContainer}>
          <MobileProfileMenu />
          <Typography variant="h5" className={styles.title}>
            Social
          </Typography>
        </div>
      ) : (
        <div className={styles.stickToEnd} />
      )}
      <IconButton
        onClick={() => openTopLevelDialog(TopLevelDialogNames.GroupMembers)}
      >
        <GroupSecondIcon variant="outlined" />
      </IconButton>
      <ChatIconButton />
      <NotificationMenu />
      <IconButton className={styles.profileButton} onClick={onProfileClick}>
        {personalDetails?.traveller?.s3_profile_pic ? (
          <Avatar
            cloudinaryPath={personalDetails?.traveller?.s3_profile_pic}
            size="s"
            className={styles.avatar}
          />
        ) : (
          <AvatarIcon variant="outlined" />
        )}
      </IconButton>
    </MobileHeader>
  );
};
export default SocialMobileHeader;
